import { scriptURL } from "../../_globals";

let codeTemplate = `
<div 
INSERTION_POINT
    style="text-align: center; color: rgba(90, 90, 90, 0.5)">
    Events Loading
</div>
<script
    src="${scriptURL}"
    type="text/javascript"
></script>
`;

export default codeTemplate;
